export function useMessage() {
  // TODO: 对应的 弹窗设置
  return {} as any
}
